<div class="notification-container" *ngIf="messages.length">
  <div [@slideInOut] *ngFor="let message of messages" class="notification-item" [ngClass]="message.type">
    <mat-icon *ngIf="message.type === 'success'">check_circle_outline</mat-icon>
    <mat-icon *ngIf="message.type === 'error'">highlight_off</mat-icon>
    <mat-icon *ngIf="message.type === 'info'">info</mat-icon>
    <mat-icon *ngIf="message.type === 'warning'">warning</mat-icon>
    <div class="text">{{message.text}}</div>
  </div>
</div>